import axios from 'axios'

const state = () => ({
  pagesImages: []
})

const getters = {
  pagesImages(state) {
    return state.pagesImages
  }
}

const mutations = {
  SET_PAGES_IMAGES(state, payload){
    state.pagesImages = payload
  }
}

const actions = {
  getPagesImages({commit}){
    axios.get('https://api.geomalaka.uz/api/main/menus_image/')
    .then((res)=>{
      commit("SET_PAGES_IMAGES", res.data)
    })
    .catch((error)=>{console.log(error)})
  }
}

export default{
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
